import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';

export interface VantageScoreRatingObject {
  rating: string;
  vantageScoreColor: string;
  startingDegree: number;
  degreeRange: number;
  ratingMinScore: number;
  vantageScoreRange: number;
}

@Component({
    selector: 'app-credit-score',
    templateUrl: './credit-score.component.html',
    styleUrls: ['./credit-score.component.scss'],
    standalone: false
})
export class CreditScoreComponent implements OnInit, AfterViewInit {
  @Input() isCreditScoreAvailable: boolean;
  @Input() vantageScore: number;
  @Output() onClickCreditManager: EventEmitter<null> = new EventEmitter();
  vantageScoreDegree: number;
  vantageScoreRating: VantageScoreRatingObject;

  @ViewChild('scorePointer') scorePointerElement: ElementRef;
  @ViewChild('scorePointerColor') scorePointerColorElement: ElementRef;

  ngOnInit(): void {
    this.vantageScoreRating = this.vantageScoreRatingHelper(this.vantageScore);
    this.vantageScoreDegree = this.vantageScoreDegreeHelper(this.vantageScore, this.vantageScoreRating);
  }

  ngAfterViewInit() {
    // if this conditional doesn't check out, we aren't rendering the pointer, so nativeElement will be undefined
    if (this.isCreditScoreAvailable && this.vantageScoreRating.rating !== 'unknown') {
      this.scorePointerElement.nativeElement.setAttribute('style', `transform: rotate(${this.vantageScoreDegree}deg)`);
      this.scorePointerColorElement.nativeElement.setAttribute(
        'style',
        `fill: ${this.vantageScoreRating.vantageScoreColor}`
      );
    }
  }

  emitCreditManagerClick() {
    this.onClickCreditManager.emit();
  }

  private vantageScoreDegreeHelper(vantageScore: number, vantageScoreRating: VantageScoreRatingObject) {
    return (
      vantageScoreRating.startingDegree +
      ((vantageScore - vantageScoreRating.ratingMinScore) / vantageScoreRating.vantageScoreRange) *
        vantageScoreRating.degreeRange
    );
  }

  private vantageScoreRatingHelper(vantageScore: number) {
    if (vantageScore >= 781 && vantageScore <= 850) {
      return {
        rating: 'excellent',
        vantageScoreColor: '#011835',
        startingDegree: 206,
        degreeRange: 20,
        ratingMinScore: 781,
        vantageScoreRange: 40,
      };
    }
    if (vantageScore >= 720) {
      return {
        rating: 'good',
        vantageScoreColor: '#011835',
        startingDegree: 176,
        degreeRange: 30,
        ratingMinScore: 720,
        vantageScoreRange: 60,
      };
    }
    if (vantageScore >= 658) {
      return {
        rating: 'fair',
        vantageScoreColor: '#011835;',
        startingDegree: 151,
        degreeRange: 25,
        ratingMinScore: 658,
        vantageScoreRange: 62,
      };
    }
    if (vantageScore >= 601) {
      return {
        rating: 'poor',
        vantageScoreColor: '#011835;',
        startingDegree: 126,
        degreeRange: 25,
        ratingMinScore: 601,
        vantageScoreRange: 57,
      };
    }
    if (vantageScore >= 300) {
      return {
        rating: 'very poor',
        vantageScoreColor: '#011835;',
        startingDegree: -2,
        degreeRange: 125,
        ratingMinScore: 300,
        vantageScoreRange: 300,
      };
    }
  
    return {
      rating: 'unknown',
      vantageScoreColor: '#dddddd;',
      startingDegree: 0,
      degreeRange: 1,
      ratingMinScore: 0,
      vantageScoreRange: 0,
    };
  }
}
